import { Globe } from "lucide-react";
import { getLanguageName } from "@/config/languages";

interface Props {
  enabledLanguages: string[];
  currentLanguage: string;
  onSelect: (code: string) => void;
  className?: string;
}

/** Footer language picker for public storefronts — lists only the store's enabled languages. */
export function StoreLanguageSwitcher({ enabledLanguages, currentLanguage, onSelect, className }: Props) {
  if (enabledLanguages.length < 2) return null;
  return (
    <label translate="no" className={`inline-flex items-center gap-2 text-sm ${className ?? ""}`}>
      <Globe className="h-4 w-4" aria-hidden />
      <select
        aria-label="Langue de la boutique"
        data-testid="store-language-select"
        value={currentLanguage}
        onChange={(e) => onSelect(e.target.value)}
        className="bg-transparent border border-current/20 rounded-md px-2 py-1 text-inherit"
      >
        {enabledLanguages.map((code) => (
          <option key={code} value={code} className="text-foreground bg-background">
            {getLanguageName(code)}
          </option>
        ))}
      </select>
    </label>
  );
}
